import { Dialog } from "primereact/dialog";
import { useEffect, useState, useRef } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { MultiSelect } from "primereact/multiselect";
import { Fetch } from "../../../../shared/Fetch";
import { ITopic } from "../trainingTopics/Table";

interface IProps {
    open: boolean,
    category_ID: number | null,
    hideDialog: () => void,
    toast: any,
}

export const TopicLink = (props: IProps) => {
    const [selectedTopics, setSelectedTopics] = useState<Array<ITopic>>([]);
    const [allTopics, setAllTopics] = useState<Array<ITopic>>([]);
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: ITopic[], loading: boolean });

    // const dt = useRef<any>(null);

    const loadTopics = async () => {
        const res = await Fetch("CarnivalTraining/getActiveTopicsForCategoryMap", "GET", null, `category_ID=${props.category_ID}`, props.toast);
        if (res) {
            const data: ITopic[] = await res.json();
            setAllTopics(data);
        }
    };

    const loadAddedTopics = async () => {
        if (!props.category_ID) return;

        const res = await Fetch("CarnivalTraining/getCategoryTopics", "GET", null, `category_ID=${props.category_ID}`, props.toast);
        if (res) {
            const data = await res.json();
            setTableData({ tableData: data, loading: false });
            setSelectedTopics([]);
        }
    };


    const onSubmit = async () => {
        if (!props.category_ID) return;

        const body: any = {
            category_ID: props.category_ID,
            topic_IDs: selectedTopics,
        };

        const res = await Fetch("CarnivalTraining/addCategoryTopic", "POST", body, null, props.toast);
        if (res) {
            props.toast.current.show({ severity: 'success', detail: "Saved", life: 3000 });
            loadAddedTopics().then(() => loadTopics());
        }
    };

    const deleteCategory = async (row: any) => {
        const res = await Fetch("CarnivalTraining/removeCategoryTopic", "DELETE", null, `link_ID=${row.link_ID}`, props.toast);

        if (res) {
            props.toast.current.show({ severity: "success", detail: "Deleted", life: 2000 });

            await loadAddedTopics();
            await loadTopics();
        }
    };

    const actionBody = (row: ITopic) => (
        <Button icon="pi pi-trash" className="p-button-danger" onClick={() => deleteCategory(row)} />
    );

    const status = (row: ITopic) => {
        return <p className="" style={{ color: (row.topic_Status === true ? "green" : "red") }}>{row.topic_Status === true ? "Active" : "Inactive"}</p>
    }

    const onHide = () => {
        setSelectedTopics([]);
        setTableData({ tableData: [], loading: false });
        props.hideDialog();
    }

    useEffect(() => {
        if (props.open) {
            setSelectedTopics([]);
            loadAddedTopics().then(() => loadTopics());
        }
    }, [props.open]);

    // useEffect(() => {
    //     if (props.open) {
    //         const linkedIds = tableData.tableData.map((x: any) => x.category_ID);
    //         setTopics(allTopics.filter((cat: any) => !linkedIds.includes(cat.category_ID)));
    //     }
    // }, [allTopics, tableData, props.open]);


    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Select Topic" modal onHide={() => onHide()}>

            <MultiSelect value={selectedTopics} onChange={(e) => setSelectedTopics(e.value)} options={allTopics} optionValue="topic_ID" optionLabel="topic_Name" display="chip" filter placeholder="Select Topics" className="w-11" />

            <div className="flex justify-content-end gap-3 mt-3">
                <Button label="SAVE" onClick={onSubmit} className="p-button-success" />
                <Button label="CLOSE" onClick={props.hideDialog} className="p-button-outlined" />
            </div>

            <DataTable value={tableData.tableData} loading={tableData.loading} className="mt-4" header="Linked Topics">
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="topic_Name" header="Topic" />
                <Column field="topic_Status" header="Status" body={status} />
                <Column header="Action" body={actionBody} />
            </DataTable>
        </Dialog>
    );
}
